import React, { useCallback, useMemo } from 'react';

import { ReactComponent as ViewsIcon } from './views-icon.svg';
import { ReactComponent as ReviewsIcon } from './reviews-icon.svg';
import { postsPages } from '../../projectSubCategory/SubCategory';
import PublishedPostLabel from './PublishedPostLabel/PublishedPostLabel';
import InvitedPostLabel from './InvitedPostLabel/InvitedPostLabel';
import PendingPostLabel from './PendingPostLabel/PendingPostLabel';
import { SidekickCategories } from '../../../static/categories';
import { postStatuses } from '../Post';

export const answerStateTypes = {
    not_answered: 'not_answered',
    declined: 'declined',
    partial_accepted: 'partial_accepted',
    full_accepted: 'full_accepted',
};

const PostFooter = ({
    page,
    budget,
    category,
    subCategoryTitle,
    subCategories,
    handleResponse,
    postStatus,
    viewsCount,
    reviewsCount,
    onAcceptDecline,
    requestInvoice,
    completeProject,
    postContentWrapperClassNames,
    isProjectPostPage,
    email,
    responseEmails,
    isDeletedByAdmin,
    openPortfolioPopup,
    briefLink,
}) => {
    const style = useMemo(() => {
        return {
            backgroundColor: SidekickCategories[category.toLowerCase()]?.color || '#30CC9D',
        };
    }, [category]);

    const answerState = useMemo(() => {
        const answer = responseEmails.find(review => review.email === email);

        const state = !answer
            ? answerStateTypes.not_answered
            : answer.response === 'decline'
            ? answerStateTypes.declined
            : answer.isPortfolioUploaded
            ? answerStateTypes.full_accepted
            : answerStateTypes.partial_accepted;

        return state;
    }, [responseEmails, email]);

    const handleUploadPortfolio = useCallback(
        e => {
            e.stopPropagation();
            openPortfolioPopup();
        },
        [openPortfolioPopup]
    );

    const handleShowBrief = useCallback(
        e => {
            e.stopPropagation();
            openPortfolioPopup(true);
        },
        [openPortfolioPopup]
    );

    return (
        <div className={postContentWrapperClassNames}>
            <div className="post-footer">
                <div style={style} className="post-budget">
                    {budget}
                </div>
                {(page === postsPages.published && postStatus !== postStatuses.done) ||
                (page === postsPages.invited && subCategoryTitle !== subCategories?.inProgress) ? (
                    <div className="views-count-wrap">
                        <div className="views-wrap">
                            <ViewsIcon />
                            <span className="views-count-number">{viewsCount}</span>
                        </div>
                        <div className="reviews-wrap">
                            <ReviewsIcon />
                            <span className="reviews-count-number">{reviewsCount}</span>
                        </div>
                    </div>
                ) : null}
                {page === postsPages.published && (
                    <PublishedPostLabel
                        status={postStatus}
                        subCategoryTitle={subCategoryTitle}
                        subCategories={subCategories}
                        requestInvoice={requestInvoice}
                        completeProject={completeProject}
                    />
                )}
                {((page === postsPages.invited && !isProjectPostPage) ||
                    (page === postsPages.invited && isProjectPostPage && !isDeletedByAdmin)) && (
                    <InvitedPostLabel
                        category={category}
                        subCategoryTitle={subCategoryTitle}
                        subCategories={subCategories}
                        handleResponse={handleResponse}
                        responseEmails={responseEmails}
                        isProjectPostPage={isProjectPostPage}
                        handleShowBrief={handleShowBrief}
                        answerState={answerState}
                        page={page}
                        handleUploadPortfolio={handleUploadPortfolio}
                        briefLink={briefLink}
                    />
                )}
                {page === postsPages.pending && (
                    <PendingPostLabel
                        category={category}
                        subCategoryTitle={subCategoryTitle}
                        subCategories={subCategories}
                        onAcceptDecline={onAcceptDecline}
                    />
                )}
            </div>
        </div>
    );
};

export default PostFooter;
